<template>
  <div class="Navbar">
    <div class="NavbarContent">
      <router-link class="NavbarLink" to="/">
        <div class="NavbarLogo">
          <img src="../assets/img/logo_dark.svg" alt="logo" />
        </div>
      </router-link>
      <div class="NavbarMenu">
        <router-link to="/">
          <button class="NavbarBtn btn">Back to homepage</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsNavbar",
};
</script>

<style lang="scss" scoped>
.Navbar {
  .NavbarContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 15px 0;
  }
  .NavbarLink {
    .NavbarLogo {
      img {
        width: 140px;
      }
    }
  }
  .NavbarMenu {
    display: flex;
    align-items: center;
  }
  .NavbarBtn {
    background: $color-purple;
    color: $color-white;
    transition: all 0.2s ease-out;
    &:hover {
      filter: brightness(120%);
      transition: all 0.2s ease-out;
    }
  }
}
@media screen and (max-width: 650px) {
  .NavbarContent {
    .NavbarLink {
      .NavbarLogo {
        img {
          width: 130px;
        }
      }
    }
    .NavbarBtn {
      padding: 10px 15px;
      font-size: 15px;
    }
  }
}
</style>
